import { render, staticRenderFns } from "./RM_exchange_platform-modal.vue?vue&type=template&id=3b7e5d98&scoped=true"
import script from "./RM_exchange_platform-modal.vue?vue&type=script&lang=js"
export * from "./RM_exchange_platform-modal.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "3b7e5d98",
  null
  
)

export default component.exports